import * as CameraParticipantActionTypes from "./actionTypes";
import ReducerRegistry from "../base/redux/ReducerRegistry";
const initialState = {
    instances: new Map(),
};
export const cameraParticipantReducer = (state = initialState, action) => {
    switch (action.type) {
        case CameraParticipantActionTypes.ADD_CAMERA_PARTICIPANT_SUCCESS: {
            const { payload } = action;
            const newMap = new Map(state.instances);
            newMap.set(payload.deviceId, payload);
            return {
                ...state,
                instances: newMap,
            };
        }
        case CameraParticipantActionTypes.REMOVE_CAMERA_PARTICIPANT_SUCCESS: {
            const { payload } = action;
            const map = new Map(state.instances);
            map.delete(payload.deviceId);
            return {
                ...state,
                instances: map
            };
        }
        default:
            return state;
    }
};
ReducerRegistry.register('features/camera-participant', cameraParticipantReducer);
